import { cn as e } from "../../lib/utils.es.js";
import { Avatar as t, AvatarFallback as n } from "../ui/avatar.es.js";
import { Tooltip as r, TooltipContent as i, TooltipTrigger as a } from "../ui/tooltip.es.js";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
// libs/ui-lib/src/components/UserAvatar/UserAvatar.tsx
var c = [
	"bg-emerald-100 text-emerald-700",
	"bg-blue-100 text-blue-700",
	"bg-purple-100 text-purple-700",
	"bg-amber-100 text-amber-700",
	"bg-turquoise-15 text-turquoise-dark",
	"bg-rose-100 text-rose-700"
];
function l(e) {
	let t = e.trim();
	if (!t) return "–";
	let n = t.split(/\s+/);
	return `${n[0]?.[0] ?? ""}${n.length > 1 ? n[n.length - 1]?.[0] ?? "" : ""}`.toUpperCase();
}
function u(e) {
	let t = 0;
	for (let n = 0; n < e.length; n++) t = t * 31 + e.charCodeAt(n) >>> 0;
	return c[t % c.length] ?? "bg-muted text-foreground";
}
function d({ name: c, email: d, seed: f, size: p = "md", className: m, variant: h = "colorful", showTooltip: g = !0 }) {
	let _ = p === "sm" ? "size-6" : "size-7", v = c.trim(), y = d?.trim(), b = g && (!!v || !!y), x = h === "muted" ? "bg-muted text-muted-foreground" : u(f ?? c), S = /* @__PURE__ */ o(t, {
		className: e(_, m),
		children: /* @__PURE__ */ o(n, {
			className: e("font-medium text-xs", x),
			children: l(c)
		})
	});
	return b ? /* @__PURE__ */ s(r, { children: [/* @__PURE__ */ o(a, {
		asChild: !0,
		children: /* @__PURE__ */ o("span", {
			className: "inline-flex",
			children: S
		})
	}), /* @__PURE__ */ s(i, {
		className: "z-[1100] flex flex-col gap-0.5 text-center",
		children: [v ? /* @__PURE__ */ o("span", {
			className: "font-medium",
			children: v
		}) : null, y ? /* @__PURE__ */ o("span", {
			className: "opacity-80",
			children: y
		}) : null]
	})] }) : S;
}
export { d as UserAvatar };
